

/*====== import  ======*/
/*------ React ------*/
import React, { useEffect } from "react"
/*------ CSS ------*/
// import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { useProvideData } from "03CommonApiParts/use-context";
import { USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { cognitoSignOutURL } from "03CommonApiParts/authConfig";
import { async } from "q";
/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/

/*====== global functions ======*/

/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const LOGOUT = () =>{ //ログアウト後の画面
    const apiData = useProvideData();	//APIデータ取得

    

    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    useEffect(()=>{
        const postSingOut = async() =>{
            const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
            var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    
            /* リクエスト*/
            const handlingInformation = {};
    
            /* 操作情報 */
            handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
    
            /* リクエスト先 */
            const apiPath = '/authorization/postsignout';	//API Path
            
            /* リクエストパラメータ */
            const apiBody = {handlingInformation: handlingInformation};
        
            /* API処理開始 */
            await apiData.getDataPost(apiPath, apiBody, (result) => {
                if(result.isSuccessed) {
                    console.log('logout successful')
                }
            });
        };
        postSingOut();
        sessionStorage.clear();
        window.top.location = cognitoSignOutURL;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    /* --------------------------- */
    /* ---------- data ----------- */
    /* --------------------------- */

    
    return(
        <>
            <LoadingProgressBar open={true}/>
        </>
    );
}